export default __webpack_public_path__ + "static/media/doc_po.aec67cfa.pdf";